//TODO: Adjust to the updated theme
export const BeeCrewShadows = {
  primary: {
    base: '0px 1px 2px 0px rgba(212, 147, 8, 0.10), 0px 4px 4px 0px rgba(212, 147, 8, 0.09), 0px 8px 5px 0px rgba(212, 147, 8, 0.05), 0px 14px 6px 0px rgba(212, 147, 8, 0.01), 0px 22px 6px 0px rgba(212, 147, 8, 0.00)',
    hover:
      '0px 2px 4px 0px rgba(214, 146, 0, 0.10), 0px 7px 7px 0px rgba(214, 146, 0, 0.09), 0px 16px 10px 0px rgba(214, 146, 0, 0.05), 0px 28px 11px 0px rgba(214, 146, 0, 0.01), 0px 44px 12px 0px rgba(214, 146, 0, 0.00)',
  },
  secondary: {
    base: '0px 1px 2px 0px rgba(171, 171, 171, 0.10), 0px 4px 4px 0px rgba(171, 171, 171, 0.09), 0px 8px 5px 0px rgba(171, 171, 171, 0.05), 0px 14px 6px 0px rgba(171, 171, 171, 0.01), 0px 22px 6px 0px rgba(171, 171, 171, 0.00)',
    hover:
      '0px 2px 4px 0px rgba(112, 112, 112, 0.10), 0px 7px 7px 0px rgba(112, 112, 112, 0.09), 0px 16px 9px 0px rgba(112, 112, 112, 0.05), 0px 28px 11px 0px rgba(112, 112, 112, 0.01), 0px 43px 12px 0px rgba(112, 112, 112, 0.00)',
  },
}
